import React, {Fragment, PropsWithChildren, useRef, useState} from 'react';
import {default as SelectControl, createFilter} from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { components } from 'react-select';
import {sendRequest} from '../../utils/request';
import isEqual from 'lodash-es/isEqual';
import config from "../../config/config";
import axios from "axios";
import classNames from 'classnames';
import {get, set} from "../../utils/dotutils";
import {list} from "../../utils/array";
import debounce from "../../utils/debounce";
import {empty} from "locutus/php/var";
import ComponentConfig from "./ComponentConfig";
import {optionsTemplate} from "../../utils/formatters";
import Confirm from "./Confirm";
import CheckBox from "./CheckBox";
import SelectorGrid from "./SelectorGrid/SelectorGrid";
import Icon from "./Icon";
import Label from './Label';
import PromiseRequest from "../../utils/promise/PromiseRequest";
import {ComponentConfigType} from "../../utils/ComponentConfigType";

export type SelectPropsType = {
    storeType: "local"|"remote",
    url?: string,
    saveChanges?: (field: string, value: any, e: Event) => void,
    onSelect?: (value: any) => void,
    valueKey?: string,
    labelKey?: string,
    optionsTemplate?: any,
    selectedOptionTemplate?: any,
    disabledKey?: string,
    matchmode?: string,
    searchtype?: string,
    component?: string,
    listfield?: string,
    optionname?: string,
    optioncomponent?: string,
    isLoading?: boolean,
    placeholder?: string,
    isSearchable?: boolean,
    isCreatAble?: boolean,
    isClearable?: boolean,
    isMulti?: boolean,
    minLength?: number,
    options?: any[],
    limit?: number,
    filter?: any,
    order?: any,
    groupBy?: any,
    parameters?: Record<string, any>,
    value?: any,
    inputValue?: string,
    label?: any,
    required?: boolean,
    disabled?: true|false,
    readOnly?: true|false,
    error?: any,
    warning?: any,
    valid?: any,
    name?: string,
    createOptionPosition?: "first"|"last",
    formatCreateLabel?: (value: string) => string,
    autoSelect?: boolean
    objectValue?: boolean
    isOptionDisabled?: (option: any) => boolean,
    view?: any,
    onLoadCompleted?: (options: any[], search: string) => void|any[]|Promise<void>|Promise<any[]>,
    onInputValueChanged?: (q: string) => void,
    className?: string|Record<string, any>,
    openIfHasOptions?: boolean
    searchFormatter?: (string|((search: string) => string))[]|string|((search: string) => string),
    focus?: boolean,
    autoFocus?: boolean,
    menuIsOpen?: boolean,
}

type ActionMetaType = {action: string, name: string, option: any};

const placeHolderComponent = (props: SelectPropsType) => <div className="ph-item ph-select">
    <div className="ph-col-12">
        <div className="ph-row">
            {props.label && <div className="ph-col-4 label" />}
            <div className="ph-col-12 input" />
        </div>
    </div>
</div>;

const moreID = "moreID" + (new Date().getTime());

function removeDuplicates(myArr: any[], prop: string) {
    return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
}

const lastRequests: Record<string, PromiseRequest<any>> = {};

function PopUpSelectList(props: SelectPropsType&{finder?: any, selectByList?: any}) {

    let finder = null;

    const icon = <div className="react-select__indicator react-select__more-indicator">
        <Icon lib="fa" name="search" />
    </div>;

    if (props.finder) {
        if (props.finder instanceof Function) {
            finder = <props.finder icon={icon} />
        } else {
            finder = <props.finder.type ref={props.finder.ref} icon={icon} {...props.finder.props} />
        }
    } else {

        if (!(props.component && (props?.selectByList || props?.optionsTemplate?.columns))) {
            return null;
        }

        if (props.component && props?.optionsTemplate?.component && props.component !== props?.optionsTemplate?.component) {
            return null;
        }

        const [checkedList, setCheckedList] = useState(Array.isArray(props.value) ? props.value : (props.isMulti && !props.value ? [] : [props.value]));

        React.useEffect(() => {
            setCheckedList(Array.isArray(props.value) ? props.value : (props.isMulti && !props.value ? [] : [props.value]));
        }, [props.value]);

        let columns = {};

        if (props?.selectByList) {
            columns = props?.selectByList?.columns || {};
        } else if (props.optionsTemplate && props.optionsTemplate instanceof Object) {
            columns = props.optionsTemplate?.columns || {};
        }

        let view = props.view;
        if (Array.isArray(view)) {
            view = [...view];
            view.push(props.labelKey);
            view.push(props.valueKey);
        } else if (view && view instanceof Object) {
            view = {...view, [props.labelKey]: "", [props.valueKey]: ""};
        } else {
            view = [props.labelKey, props.valueKey];
        }

        columns = {
            ...(columns || {}),
            "actions": {
                header: ' ',
                width: 1,
                renderer: (value, rowData) => {
                    let place = checkedList.findIndex((item) => {
                        if (item && item instanceof Object) {
                            return item[props.valueKey] + "" === "" + rowData[props.valueKey];
                        } else if (item) {
                            return item + "" === "" + rowData[props.valueKey];
                        }
                        return false;
                    });
                    return <CheckBox
                        name="token"
                        label={false}
                        checked={place !== -1}
                        saveChanges={() => {
                            let newItem = null;
                            if (props.objectValue !== false) {
                                newItem = rowData;
                            } else {
                                newItem = rowData[props.valueKey];
                            }
                            if (props.isMulti) {
                                if (place === -1) {
                                    setCheckedList([...checkedList, newItem])
                                } else {
                                    let newCheckedList = [...checkedList];
                                    newCheckedList.splice(place, 1)
                                    setCheckedList(newCheckedList);
                                }
                            } else {
                                if (props.isClearable && place !== -1) {
                                    setCheckedList([undefined]);
                                } else {
                                    setCheckedList([newItem]);
                                }
                            }

                        }}
                    />
                }
            }
        }

        finder = <Confirm
            size="large"
            disabled={props.disabled}
            body={<div className="option-container" onClick={(e) => {
                e && e.stopPropagation();
            }} onKeyDown={(e) => {
                e && e.stopPropagation();
            }}>
                <SelectorGrid
                    view={view}
                    component={props.component}
                    columns={columns}
                    filter={props.filter}
                />
            </div>}
            onAccept={async (e) => {
                let value = null;
                if (props.isMulti) {
                    value = checkedList;
                } else {
                    value = checkedList[0];
                }
                if (props.onSelect) {
                    props.onSelect(value);
                }
                if (props.saveChanges) {
                    props.saveChanges(props.name, value, e);
                }
            }}
        >
            {icon}
        </Confirm>;
    }

    return <Fragment>
        {finder}
        <span className="react-select__indicator-separator" />
    </Fragment>

}

class Control extends React.Component<{selectProps: {popUpSelectListProps: SelectPropsType}}> {
    render() {
        return (
            <components.Control {...this.props}>
                <PopUpSelectList
                    {...this.props.selectProps.popUpSelectListProps}
                />
                {this.props.children}
            </components.Control>
        );
    }
}

class Dots extends React.Component {
    state = {
        dotCount: 0
    }

    interval: number;

    componentDidMount() {
        this.interval && window.clearInterval(this.interval);
        this.interval = window.setInterval(() => {
            this.setState({
                dotCount: this.state.dotCount > 2 ? 0 : this.state.dotCount + 1
            })
        }, 300);
    }

    componentWillUnmount() {
        this.interval && window.clearInterval(this.interval);
    }

    render() {
        return ".".repeat(this.state.dotCount);
    }
}

class LazyLoad extends React.Component<{load: () => void}> {

    el = React.createRef<HTMLDivElement>();

    componentDidMount() {
        if (this.el.current) {
            const observer = new IntersectionObserver((entries) => {
                // isIntersecting is true when element and viewport are overlapping
                // isIntersecting is false when element and viewport don't overlap
                if (entries[0].isIntersecting === true) {
                    console.log('Element has just become visible in screen');
                    this.props.load && this.props.load();
                }
            }, {threshold: [0]});

            observer.observe(this.el.current);
        }
    }

    componentWillUnmount() {
    }

    render() {
        return <div ref={this.el} />;
    }
}

const SelectMenuButton = (action: () => void|Promise<void>) => (props: PropsWithChildren<SelectPropsType>) => {
    const el = useRef();
    return (
        <components.MenuList {...props} ref={el}>
            {props.children}
            <LazyLoad load={async () => {
                await action();
                console.log(el);
            }} />
        </components.MenuList >
    )
}

type SelectStateType = {
    options?: any[],
    labelKey?: string,
    valueKey?: string,
    isLoading?: boolean,
    fullcount?: number,
    optionIsLoading?: boolean,
    usedoptions?: any[],
    search?: string,
    isFocused?: boolean,
    pageSize?: number
}

type SelectCompPropsType = SelectPropsType&{
    componentConfig?: ComponentConfigType&{namefield?: string},
    targetConfig?: ComponentConfigType&{namefield?: string},
}

class SelectComp extends React.Component<SelectCompPropsType, SelectStateType> {

    el: React.RefObject<any>;

    static placeHolder = placeHolderComponent;

    optionsLoaded = async (options: any[] = [], listparams: any = null, queryParams: any = null, fullcount: number|null = null) => {
        listparams = listparams || {
            optionname: this.props.optionname
        };
        queryParams = queryParams || {
            labelKey: this.state.labelKey,
            valueKey: this.state.valueKey,
        }
        const onLoadCompleted = async (options: any[], search: string) => {
            if (this.props.onLoadCompleted) {
                let newOptions = await this.props.onLoadCompleted(options, search);
                if (Array.isArray(newOptions)) {
                    return newOptions;
                }
            }
            return options;
        }
        options = await onLoadCompleted(options, listparams.search);
        // TODO ezt azért majd ha az option language stb össze van rakva ki kéne venni
        if (listparams.optionname) {
            options = removeDuplicates(options, "optionid");
        }
        const changed = JSON.stringify(options) !== JSON.stringify(this.state.options);
        this.setState({
            labelKey: queryParams.labelKey,
            valueKey: queryParams.valueKey,
            optionIsLoading: false,
            options,
            fullcount
        }, () => {
            changed && this.autoSelect();
        });
    }

    isRemote = () => this.props.storeType === "remote" || (this.props.storeType === "local" && (this.props.options === undefined || this.props.options === null));

    promisedSetState = (newState: SelectStateType) => {
        return new Promise<void>((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    loadOptions: (options?: any[]) => void;
    lastOptionRequestAbort?: () => Promise<void>;
    lastRequestAbort?: () => Promise<void>;

    constructor(props: SelectCompPropsType) {
        super(props);
        this.el = React.createRef();
        this.state = {
            isLoading: false,
            fullcount: null,
            optionIsLoading: false,
            options: [],
            usedoptions: [],
            search: props.inputValue !== undefined && props.inputValue !== null ? props.inputValue : '',
            isFocused: false,
            pageSize: config.defaultPageSize
        };
        this.loadOptions = debounce(async (options: any[] = []) => {
            if (this.isRemote()) {
                this.lastOptionRequestAbort && await this.lastOptionRequestAbort();
                const queryParams = await this.generateQueryParams(this.props, this.state);
                const listparams = queryParams.listparams;
                if (!listparams) {
                    await this.optionsLoaded(options, listparams, queryParams);
                } else {
                    await this.promisedSetState({optionIsLoading: true});
                    if (options.length) {
                        listparams.filter = list(listparams.filter, {field: queryParams.valueKey, value: options.map((v) => {
                                if (typeof (v) === "object" && v) {
                                    return v[queryParams.valueKey];
                                }
                                return v;
                            }),
                            operator: "not in"
                        })
                    }
                    const key = JSON.stringify(listparams);

                    let aborted = false;

                    let optionRequest;
                    if (lastRequests[key]) {
                        optionRequest = lastRequests[key];
                    } else {
                        lastRequests[key] = optionRequest = sendRequest(listparams, {url: this.props.url});
                    }
                    optionRequest.then(async (data) => {
                        if (aborted) return;
                        delete lastRequests[key];
                        await this.optionsLoaded([...options, ...(data.items || [])], listparams, queryParams, data.fullcount);
                    });
                    this.lastOptionRequestAbort = async () => {
                        aborted = true;
                        await this.promisedSetState({optionIsLoading: false});
                    }
                }
            } else {
                await this.optionsLoaded(this.props.options || []);
            }
        }, 300);
    }

    loadValues = async () => {
        this.lastRequestAbort && await this.lastRequestAbort();
        await this.promisedSetState({isLoading: false});
        if (this.isRemote()) {
            await this.promisedSetState({isLoading: true});
            if (!this.props.options) {
                const queryParams = await this.generateQueryParams(this.props, this.state, this.props.value === false ? null : this.props.value);
                let listparams = queryParams.listparams;
                if (!listparams) {
                    await this.promisedSetState({
                        isLoading: false,
                        usedoptions: []
                    });
                } else {
                    const props = this.props;
                    const valueKey = queryParams.valueKey;
                    let value = props.value;
                    if (props.isMulti) {
                        if (!Array.isArray(value)) {
                            if (value) {
                                value = [value];
                            } else {
                                value = [];
                            }
                        }
                        if (value.length) {
                            if ((props.objectValue === undefined || props.objectValue === true) && typeof (value[0]) !== "object") {
                                const values = [...(props.options || this.state.options), ...this.state.usedoptions];
                                if (values.length > 0) {
                                    value = removeDuplicates(values, valueKey).filter((option) => value.indexOf(option[valueKey]) !== -1).map((option) => option[valueKey]);
                                }
                            } else if (typeof (value[0]) === "object") {
                                value = value.map((v) => v[valueKey]);
                            }
                        }
                    } else {
                        if ((props.objectValue === undefined || props.objectValue === true) && typeof (value) !== "object") {
                            const values = [...(props.options || this.state.options), ...this.state.usedoptions];
                            if (values.length > 0) {
                                value = (removeDuplicates(values, valueKey).find((option) => option[valueKey] == value) || {});
                            }
                        }
                        value = typeof (value) === 'object' && value !== null && value !== undefined ? (value[valueKey] || null) : (value !== null && value !== undefined ? (value || null) : null);
                    }

                    if (Array.isArray(value)) {
                        if (value && value.length) {
                            listparams.filter = [{field: queryParams.valueKey, value: value, operator: "in"}];
                        }
                    } else {
                        if (value) {
                            listparams.filter = [{field: queryParams.valueKey, value: value}];
                        }
                    }
                    const key = JSON.stringify(listparams);
                    
                    let aborted = false;
                    
                    let request;
                    if (lastRequests[key]) {
                        request = lastRequests[key];
                    } else {
                        lastRequests[key] = request = sendRequest(listparams, {url: this.props.url});
                    }
                    this.lastRequestAbort = async () => {
                        aborted = true;
                        await this.promisedSetState({
                            isLoading: false,
                            usedoptions: []
                        });
                    }
                    request.then((data) => {
                        if (aborted) return;
                        delete lastRequests[key];
                        this.promisedSetState({
                            labelKey: queryParams.labelKey,
                            valueKey: queryParams.valueKey,
                            isLoading: false,
                            usedoptions: [...(data.items || [])],
                        });
                    });
                    request.catch((e) => {
                        if (aborted) return;
                        delete lastRequests[key];
                        if (!(e instanceof axios.Cancel) && e.message) {
                            console.log(e);
                            this.promisedSetState({
                                labelKey: queryParams.labelKey,
                                valueKey: queryParams.valueKey,
                                isLoading: false,
                                usedoptions: []
                            });
                        }
                    });
                }
            } else {
                await this.promisedSetState({isLoading: false, usedoptions: []});
            }
        } else {
            await this.promisedSetState({isLoading: false, usedoptions: []});
        }
    }

    autoSelect = () => {
        if (this.state.options.length === 1 && this.props.autoSelect) {
            if (this.props.isMulti) {
                this.handleChange([...(this.props.value || []), this.state.options[0]]);
            } else {
                this.handleChange(this.state.options[0]);
            }
        }
    }

    componentDidMount() {
        if (this.props.focus || this.props.autoFocus) {
            this.focus();
        }
        this.componentDidUpdate({}, {});
    }

    refresh = () => {
        this.componentDidUpdate({}, {});
    }

    componentDidUpdate(prevProps: SelectCompPropsType, prevState: SelectStateType) {
        const current = this.generateQueryParams(this.props, this.state);
        const prev = this.generateQueryParams(prevProps, prevState);
        const sameValue = JSON.stringify(this.props.value) === JSON.stringify(prevProps.value)
        const sameOptions = JSON.stringify(this.props.options) === JSON.stringify(prevProps.options);
        const call = () => {
            if (!sameValue) {
                this.loadValues();
            }
            this.loadOptions();
        }
        if (!isEqual(current, prev) || !sameValue) {
            if (current) {
                this.setState({
                    labelKey: current.labelKey,
                    valueKey: current.valueKey,
                }, call);
            } else {
                call();
            }
        } else if (!sameOptions) {
            call();
        } else if (!this.state?.valueKey) {
            this.setState({
                labelKey: current?.labelKey,
                valueKey: current?.valueKey,
            });
        }
        const prevFocus = prevProps.focus || prevProps.autoFocus;
        const focus = this.props.focus || this.props.autoFocus;
        if (prevFocus !== focus && focus) {
            this.focus();
        }
    }

    componentWillUnmount() {
        //this.lastrequest && this.lastrequest.abort();
        //this.lastOptionRequest && this.lastOptionRequest.abort();
    }

    emptyMessage = () => {
        if(this.state.optionIsLoading) {
            return "Keresés...";
        }
        return this.props.storeType !== "remote" || this.state.search.length >= (this.props.minLength || config.minimumLengthOfSearch) ? "Nincs találat" : "Legalább 3 karaktert írj be a kereséshez!";
    }

    handleInputChange = (q: string, e: ActionMetaType) => {
        if (e.action === "input-change") {
            if (q !== this.state.search) {
                const state: SelectStateType = {
                    search: q,
                };
                if (this.props.storeType === "remote") {
                    state.fullcount = null;
                    state.options = [];
                }
                this.setState(state, () => {
                    if (this.props.onInputValueChanged) {
                        this.props.onInputValueChanged(q);
                    }
                });
            }
        }
    }

    getOptionsTemplate = () => {
        if (this.props.component) {
            return this.props.optionsTemplate || optionsTemplate(this.props.component);
        } else {
            return this.props.optionsTemplate;
        }
    }

    generateQueryParams = (props: SelectCompPropsType, state: SelectStateType, values = false) => {
        if (values !== false && empty(values)) {
            return {listparams: undefined, valueKey: undefined, labelKey: undefined, prepared: false};
        }
        let valueKey = props.valueKey || (props.optionname ? 'optionid' : 'id');
        let labelKey = props.labelKey || (props.optionname ? 'optionlabel' : 'label');

        const componentConfig = props.componentConfig;
        const targetConfig = props.targetConfig;
        if (!props.labelKey) {
            // TODO adapter fielddefs
            if (componentConfig?.namefield) {
                labelKey = componentConfig?.namefield;
            } else if (componentConfig?.fielddefs?.name) {
                labelKey = "name";
            } else if (componentConfig?.fielddefs?.title) {
                labelKey = "title";
            } else if (componentConfig?.fielddefs?.label) {
                labelKey = "label";
                // decorator config field
            } else if (targetConfig?.namefield) {
                labelKey = targetConfig?.namefield;
            } else if (targetConfig?.fielddefs?.name) {
                labelKey = "name";
            } else if (targetConfig?.fielddefs?.title) {
                labelKey = "title";
            } else if (targetConfig?.fielddefs?.label) {
                labelKey = "label";
            }
        }
        if (!props.valueKey) {
            valueKey = componentConfig?.idfield;
        }
        valueKey = valueKey || (props.optionname ? 'optionid' : 'id');
        labelKey = labelKey || (props.optionname ? 'optionlabel' : 'label');

        const listparams: Record<string, any> = {
            option: "componentlist",
            matchmode: props.matchmode || "any",
            searchtype: props.searchtype || null,
            component: props.component || "option",
            group: props.groupBy,
            order: props.order,
            itemsperpage: props.storeType && props.storeType === "local" ? 0 : props.limit || this.state.pageSize || config.defaultPageSize,
        };
        if (props.listfield) {
            listparams.listfield = props.listfield;
        }
        if (props.optioncomponent) {
            listparams.optioncomponent = props.optioncomponent;
        }
        if (props.storeType === "remote" && !values) {
            let search = state.search;
            if (props.searchFormatter) {
                let searchFormatter = list(props.searchFormatter);
                searchFormatter.forEach((formatter: any) => {
                    if (formatter instanceof Function) {
                        search = formatter(search);
                    } else {
                        search = formatter;
                    }
                });
            }
            if (search) {
                search = `${search}`;
            } else {
                search = "";
            }
            if (search && search.length >= (props.minLength || config.minimumLengthOfSearch)) {
                listparams.search = search.trim();
            } else {
                return {listparams: undefined, valueKey, labelKey, prepared: false};
            }
        }
        if (!props.component) {
            listparams.optionname = props.optionname;
        } else if (!componentConfig) {
            return {listparams: undefined, valueKey, labelKey, prepared: false};
        }

        listparams.filter = list(props.filter);

        if (!empty(listparams.order)) {
            listparams.order = list(listparams.order);
            if (!listparams.order.find((order: any) => (order.field || "") === labelKey)) {
                listparams.order.push({field: labelKey, direction: "ASC"});
            }
        } else {
            listparams.order = {field: labelKey, direction: "ASC"};
        }

        listparams.parameters = props.parameters || undefined;
        listparams.view = props.view || undefined;

        // TODO undefined view to default!!!
        const template = this.getOptionsTemplate();
        if (template) {
            if (template instanceof Object) {
                let templateView = template.view || [];
                if (Array.isArray(listparams.view)) {
                    if (Array.isArray(templateView)) {
                        listparams.view = [...listparams.view, ...templateView];
                    } else if (templateView instanceof Object) {
                        const view = listparams.view;
                        listparams.view = {};
                        view.map((v) => listparams.view[v] = "");
                        listparams.view = {...listparams.view, ...templateView};
                    } else {
                        console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                    }
                } else if (listparams.view instanceof Object) {
                    if (Array.isArray(templateView)) {
                        const view = templateView;
                        templateView = {};
                        view.map((v) => templateView[v] = "");
                        listparams.view = {...listparams.view, ...templateView};
                    } else if (templateView instanceof Object) {
                        listparams.view = [...listparams.view, ...templateView];
                    } else {
                        console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                    }
                } else if (!listparams.view && templateView) {
                    listparams.view = templateView;
                } else if (!!listparams.view && !templateView) {
                    // nothing to do
                } else {
                    console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                }
            }
        }

        if (props.selectedOptionTemplate) {
            const template = props.selectedOptionTemplate;
            if (template instanceof Object) {
                let templateView = template.view || [];
                if (Array.isArray(listparams.view)) {
                    if (Array.isArray(templateView)) {
                        listparams.view = [...listparams.view, ...templateView];
                    } else if (templateView instanceof Object) {
                        const view = listparams.view;
                        listparams.view = {};
                        view.map((v) => listparams.view[v] = "");
                        listparams.view = {...listparams.view, ...templateView};
                    } else {
                        console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                    }
                } else if (listparams.view instanceof Object) {
                    if (Array.isArray(templateView)) {
                        const view = templateView;
                        templateView = {};
                        view.map((v) => templateView[v] = "");
                        listparams.view = {...listparams.view, ...templateView};
                    } else if (templateView instanceof Object) {
                        listparams.view = [...listparams.view, ...templateView];
                    } else {
                        console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                    }
                } else if (!listparams.view && templateView) {
                    listparams.view = templateView;
                } else if (!!listparams.view && !templateView) {
                    // nothing to do
                } else {
                    console.error(`Select view not compatible with option template view! ${listparams.view} - ${templateView}`);
                }
            }
        }

        if (Array.isArray(listparams.view)) {
            if (listparams.view.indexOf(valueKey) === -1) {
                listparams.view.push(valueKey);
            }
            if (listparams.view.indexOf(labelKey) === -1) {
                listparams.view.push(labelKey);
            }
            const listview = listparams.view;
            listparams.view = {};
            listview.map((field) => {
                set(listparams.view, field, "");
            });
        } else if (listparams.view instanceof Object) {
            if (!listparams.view[valueKey]) {
                set(listparams.view, valueKey, get(listparams.view, valueKey) || "");
            }
            if (!listparams.view[labelKey]) {
                set(listparams.view, labelKey, get(listparams.view, labelKey) || "");
            }
        } else if(props.objectValue === false) {
            listparams.view = {};
            set(listparams.view, valueKey, "");
            set(listparams.view, labelKey, "");
        } else {
            listparams.view = listparams.view || [valueKey,labelKey];
            if (Array.isArray(listparams.view)) {
                const listview = listparams.view;
                listparams.view = {};
                listview.map((field) => {
                    set(listparams.view, field, "");
                });
            }
        }
        return {listparams, valueKey, labelKey, prepared: true};
    }

    isMoreSelected = (selected: any[]|any) => {
        if (Array.isArray(selected)) {
            return !!selected.find((item) => {
                if (typeof (item) === "object" && item && item[moreID] === true) {
                    return true;
                }
                return false;
            });
        } else {
            if (typeof (selected) === "object" && selected && selected[moreID] === true) {
                return true;
            }
        }
        return false;
    }

    handleChange = async (selected: any, actionMeta?: ActionMetaType) => {
        actionMeta = actionMeta || {action: "select-option", name: this.props.name, option: undefined};
        if (this.isMoreSelected(selected)) {
            this.loadOptions(this.state.options);
            return;
        }
        let value = await this.returnValueParser(selected);
        if (this.props.onSelect) {
            this.props.onSelect(value);
        }
        if (this.props.saveChanges) {
            this.props.saveChanges(
                this.props.name,
                value,
                new CustomEvent(actionMeta.action, {
                    detail: actionMeta
                })
            );
        }
        const state: SelectStateType = {
            pageSize: config.defaultPageSize,
            fullcount: null
        };
        //if (this.props.isCreatAble && !selected) {
        //    state.search = '';
        //} else {
            if (this.props.inputValue !== undefined && this.props.inputValue !== null) {
                state.search = this.props.inputValue;
            } else {
                state.search = '';
            }
        //}
        this.setState(state, async () => {
            await this.loadValues();
            this.loadOptions();
        });
    }

    returnValueParser = async (value: any) => {
        const valueKey = this.props.valueKey || this.state.valueKey;
        if (this.props.isMulti) {
            value = list(value);
            if (value.length) {
                value = value.map((v: any) => {
                    if (typeof (v) === "object" && v) {
                        return v[valueKey];
                    }
                    return v;
                });
                if ((this.props.objectValue === undefined || this.props.objectValue === true)) {
                    value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).filter((option) => value.indexOf(option[valueKey]) !== -1);
                }
            }
        } else {
            if ((this.props.objectValue === undefined || this.props.objectValue === true) && typeof (value) !== "object") {
                value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).find((option) => option[valueKey] == value);
            } else if(this.props.objectValue === false && typeof (value) === "object") {
                if (value !== null && value !== undefined) {
                    value = value[valueKey];
                } else {
                    value = null;
                }
            }
        }
        return value;
    }

    optionValueParser = () => {
        let value = this.props.value;
        const valueKey = this.props.valueKey || this.state.valueKey;
        if (this.props.isMulti) {
            if (!Array.isArray(value)) {
                if (value) {
                    value = [value];
                } else {
                    value = [];
                }
            }
            if (value.length) {
                if (typeof (value[0]) !== "object") {
                    value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).filter((option) => value.find((v: any) => v + "" === "" + option[valueKey]));
                }
            }
            return value === undefined ? (this.props.isCreatAble ? this.props.value : []) : value;
        } else {
            if ( ! (value instanceof Object)) {
                value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).find((option) => option[valueKey] + "" === "" + value);
            } else if(value instanceof Object && value[valueKey] !== undefined) {
                value = removeDuplicates([...(this.props.options || this.state.options), ...this.state.usedoptions], valueKey).find((option) => option[valueKey] + "" === "" + value[valueKey]);
            }
            return value === undefined ? (this.props.isCreatAble ? this.props.value : null) : value;
        }
    }

    focus = () => {
        this.el.current?.focus();
    }

    render() {
        const valueKey = this.props.valueKey || this.state.valueKey;
        const labelKey = this.props.labelKey || this.state.labelKey;
        let value = this.optionValueParser();
        /*if (Array.isArray(value)) {
            value = value.map((v) => v !== null && v !== undefined && typeof v === "object" ? v[valueKey] : v);
        } else if (value !== null && value !== undefined && typeof value === "object") {
            value = value[valueKey];
        }*/
        const classNamePrefix = "react-select";
        const optionsTemplate = this.getOptionsTemplate();
        const props: Record<string, any> = {
            classNamePrefix: classNamePrefix,
            className: classNames(classNamePrefix, this.props.className, {"is-invalid": this.props.error, "is-warned": this.props.warning, "is-valid": this.props.valid}, {"react-select__creatable": this.props.isCreatAble}),
            isMulti: this.props.isMulti || false,
            onChange: this.handleChange,
            isDisabled: !!(this.props.disabled || false),
            noOptionsMessage: this.emptyMessage,
            placeholder: this.props.placeholder || "",
            isClearable: this.props.isLoading || this.state.isLoading || this.state.optionIsLoading ? false : (this.props.isClearable || false),
            allowCreateWhileLoading: false,
            onFocus: () => {
                this.setState({
                    isFocused: true
                });
            },
            onBlur: () => {
                const state: SelectStateType = {
                    isFocused: false
                };
                if (!this.props.isCreatAble) {
                    state.search = this.props.inputValue !== undefined && this.props.inputValue !== null ? this.props.inputValue : '';
                } else {
                    state.search = '';
                }
                if (state.search !== this.state.search) {
                    this.handleInputChange(state.search, {action: "input-change"} as any);
                }
                this.setState(state);
            },
            formatCreateLabel: this.props.formatCreateLabel || ((inputValue: string) => (inputValue || '').trim()),
            getNewOptionData: (inputValue: string, optionLabel: string) => {
                const option = {};
                set(option, valueKey, null);
                set(option, labelKey, optionLabel);
                return option;
            },
            name: this.props.name,
            value: value,
            getOptionValue: (option: Record<string, any>) => get(option, valueKey, undefined),
            getOptionLabel: (option: Record<string, any>) => get(option, labelKey, undefined),
            formatOptionLabel: (option: Record<string, any>, meta: {context: "menu"|"value"}) => {
                if (option[moreID] === true) {
                    return <div className="load-more-option">
                        Még több {this.state.optionIsLoading ? <Dots /> : "..."}
                    </div>
                }
                if (meta.context === "menu") {
                    if (optionsTemplate) {
                        const Template = optionsTemplate;
                        return <Template {...option} valueKey={valueKey} labelKey={labelKey} />;
                    }
                } else if (meta.context === "value") {
                    if (this.props.selectedOptionTemplate) {
                        const Template = this.props.selectedOptionTemplate;
                        return <Template {...option} valueKey={valueKey} labelKey={labelKey} />;
                    }
                }
                if (labelKey === undefined) {
                    return null;
                }
                return get(option, labelKey, undefined);
            },
            createOptionPosition: this.props.createOptionPosition || "first",
            //onInputChange: (inputValue) => this.handleChange(inputValue),
            autoFocus: this.props.focus || this.props.autoFocus || false,
            inputValue: this.props.inputValue !== undefined && this.props.inputValue !== null ? this.props.inputValue : this.state.search,
            isOptionDisabled: (option: Record<string, any>) => option && typeof option === "object" && option[this.props.disabledKey || "disabled"],
            filterOption: this.props.storeType === "remote" ? () => {
                return true;
            } : createFilter({ignoreAccents: true, matchFrom: this.props.matchmode || 'any', ignoreCase: true})
        };
        props.styles = {
            multiValueRemove: (base: Record<string, any>, state: any) => {
                return props.isDisabled ? { ...base, pointerEvents: 'none' } : base;
            }
        };

        let options = this.props.options || this.state.options;
        options = [...options];
        let values = list(value);
        if (this.props.isCreatAble && values.length && this.state.search.trim() !== '') {
            options = removeDuplicates([...values, ...options], valueKey);
        }

        if (this.props.openIfHasOptions === true) {
            if (options.length > 0 && this.state.isFocused) {
                props.menuIsOpen = true;
            } else {
                props.menuIsOpen = false;
            }
        }
        props.menuIsOpen = this.props.menuIsOpen !== undefined ? this.props.menuIsOpen : props.menuIsOpen;
        //props.menuIsOpen = true;

        if (this.props.isCreatAble) {
            props.promptTextCreator = (label: string) => {
                return `Új érték mentése: ${label}`;
            };
        }

        /*const isMore = this.isRemote() && this.state.options.length > 0 && this.state.fullcount > 0 && this.state.fullcount != this.state.options.length;
        if (isMore) {
            options.push({[moreID]: true});
        }*/
        const SelectComponent = this.props.isCreatAble ? CreatableSelect : SelectControl;
        props.isLoading = this.props.isLoading || this.state.optionIsLoading;
        props.backspaceRemovesValue = !props.isLoading;
        props.isSearchable = this.props.isSearchable !== undefined && this.props.isSearchable !== null ? this.props.isSearchable : true;
        //props.isSearchable = true;
        props.options = options;
        props.onInputChange = this.handleInputChange;
        props.loadingMessage = () => "Keresés...";
        props.menuPlacement = "auto";
        //props.closeMenuOnSelect = !isMore;
        /*props.components = {MenuList: SelectMenuButton(async () => {
            if (this.props.storeType === "remote" && this.state.options.length > 0) {
                await this.loadOptions(null, this.state.options);
            }
        })};*/
        props.components = {Control};
        props.popUpSelectListProps = {
            ...this.props,
            value: value,
            saveChanges: this.props.saveChanges,
            onSelect: this.props.onSelect,
            valueKey: valueKey,
            labelKey: labelKey,
            optionsTemplate: this.getOptionsTemplate(),
        };

        return <Fragment>
            <Label {...this.props}/>
            <SelectComponent
                ref={this.el}
                {...props}
                inputId={this.props.name}
                disabled={props.isDisabled}
            />
            {this.props.error && <div className="invalid-feedback">{this.props.error}</div>}
        </Fragment>;
    }

}

const TargetConfig = (props: SelectPropsType&{innerRef?: any, componentConfig?: ComponentConfigType&{target?: string}}) => {
    const innerRef = props.innerRef;
    props = {...props};
    delete props.innerRef;
    const comp = <SelectComp {...props} ref={innerRef} />;
    if (props.componentConfig?.target) {
        return <ComponentConfig componentName={props.componentConfig?.target} componentConfigAs="targetConfig">
            {comp}
        </ComponentConfig>
    }
    return comp;
}

TargetConfig.placeHolder = placeHolderComponent;

const Select = React.forwardRef<SelectComp, SelectPropsType>((props, ref) => {
    if (props.component) {
        return <ComponentConfig componentName={props.component}>
            <TargetConfig {...props} innerRef={ref} />
        </ComponentConfig>
    } else {
        return <SelectComp {...props} ref={ref} />;
    }
});

// @ts-ignore
Select.placeHolder = placeHolderComponent;

export default Select;
